import * as React from "react";
import { BFFGateway } from "sb-bff-integration";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { DeviceChangeDispatcherMock } from "sb-resp-utils";
import { BaseDict } from "./dict";
import { cmsConfig } from "./config";
import { LeagueListPresenter } from "./ui/LeagueListPresenter";
import { LeagueListPresenterState } from "./state";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
let _localMock;
let BFFGateWayMock;
let DataProviderMock;
let deviceChangeDispatcherMock;
if (process.env.NODE_ENV === "development") {
    _localMock = require("../../mocks");
    BFFGateWayMock = _localMock.BffGatewayMock;
    DataProviderMock = _localMock.DataProviderMock;
    deviceChangeDispatcherMock = DeviceChangeDispatcherMock.getInstance();
}
export class LeagueListPresenterRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {},
        gameStatus: {},
        timeControl: {},
        panelId: "",
        storageUtils: {},
        userInfo: {}
    }) {
        super(domId, options);
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, cmsConfig), (options.cms || {}));
        if (process.env.NODE_ENV === "development") {
            this.options.navHandler.Navigation = {
                adjustSportsPath: (url) => `en/sports/${url}`,
                getLiveEventLink: (id) => `en/live-betting/#${id}`,
                getLiveBettingLink: () => "en/live-betting"
            };
            this.options.navHandler.OpenLeague = () => { };
            this.options.navHandler.OpenCoupon = () => { };
            this.options.navHandler.centerPanelHolder = {
                element: {
                    getBoundingClientRect: () => ({ height: 1 })
                }
            },
                this.options.navHandler.topPanelsHolder = {
                    element: {
                        getBoundingClientRect: () => ({ height: 1 })
                    }
                };
            // setup data mocks for debug build
            this.dataProvider = new LeagueListPresenterState(new Parser(new Retriever(new BFFGateWayMock(), DataProviderMock, deviceChangeDispatcherMock), cmsConfig, this.options.navHandler), this.options);
            //export data store to window for debug purposes
            window["LeagueListPresenterState"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new LeagueListPresenterState(new Parser(new Retriever(new BFFGateway().withBlockId(this.options.cms.blockId), this.options.dataProvider), this.options.cms, this.options.navHandler), this.options);
        }
    }
    beforeActivate() {
        this.dataProvider.activate();
        return this;
    }
    activate() {
        return super.activate(React.createElement(LeagueListPresenter, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
}
window["LeagueListPresenter"] = LeagueListPresenterRoot;
broadcastBlockLoad("LeagueListPresenter");
//# sourceMappingURL=index.js.map